<template>
  <svg width="16" height="16" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.91172 4.03906H6.08932V6.98306H4.91172V4.03906ZM4.91113 7.57186H6.08873V8.74946H4.91113V7.57186Z"
      class="icon-warning-chip fill"
    />
    <path
      d="M6.54083 0.625305C6.33593 0.239641 5.93673 0 5.49984 0C5.06295 0 4.66374 0.239641 4.45884 0.625894L0.138232 8.78842C0.0423566 8.96767 -0.00513562 9.16881 0.000440043 9.37201C0.0060157 9.57522 0.0644666 9.77345 0.170027 9.94718C0.274067 10.1217 0.421821 10.266 0.598702 10.366C0.775583 10.4659 0.975474 10.518 1.17864 10.5171H9.82104C10.2379 10.5171 10.6153 10.304 10.8302 9.94718C10.9356 9.77339 10.994 9.57517 10.9996 9.37201C11.0051 9.16884 10.9577 8.96772 10.862 8.78842L6.54083 0.625305ZM1.17864 9.33953L5.49984 1.17701L9.82398 9.33953H1.17864Z"
      class="icon-warning-chip fill"
    />
  </svg>
</template>

<style lang="scss" scoped>
.bg-warning svg .fill,
.warning svg .fill {
  fill: #ffffff;
}

.fill {
  fill: #e40028;
}
</style>
